import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";

const formatBool = (v) => (v ? "Sim" : "Nao");

export default function MandadosPrisaoQuery({ data }) {
  const lista = Array.isArray(data?.mandadosPrisao) ? data.mandadosPrisao : [];
  const hasMandado = Boolean(data?.possuiMandado) || lista.length > 0;

  return (
    <section className="mt-6" id="mandados-prisao">
      <TitleStripe>Mandados de Prisão</TitleStripe>

      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] text-gray-500">CPF</p>
          <p className="text-sm font-semibold text-gray-900">
            {data?.cpf || "-"}
          </p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] text-gray-500">Data da consulta</p>
          <p className="text-sm font-semibold text-gray-900">
            {data?.dataConsulta || "-"}
          </p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] text-gray-500">Possui mandado</p>
          <p className="text-sm font-semibold text-gray-900">
            {formatBool(hasMandado)}
          </p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] text-gray-500">Total de mandados</p>
          <p className="text-sm font-semibold text-gray-900">{lista.length}</p>
        </div>
      </div>

      <div
        className={`mt-3 rounded-xl border ${hasMandado ? "border-red-100 bg-red-50" : "border-blue-200 bg-blue-50"} p-3`}
      >
        <p className="text-[11px] text-blue-700">Status</p>
        <p className="text-sm font-medium text-blue-900">
          {data?.status || "-"}
        </p>
      </div>

      {hasMandado ? (
        <div className="mt-4 overflow-hidden rounded-xl border border-gray-200">
          <div className="border-b border-gray-200 bg-gray-50 px-4 py-2 text-sm font-semibold text-gray-700">
            Mandados encontrados
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-white">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Numero
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Situacao
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Recaptura
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Orgao expedidor
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 bg-white">
                {lista.map((item, idx) => (
                  <tr key={`${item?.numero || "mandado"}-${idx}`}>
                    <td className="px-4 py-2 text-sm font-medium text-gray-900">
                      {item?.numero || "-"}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-700">
                      {item?.situacao || "-"}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-700">
                      {formatBool(item?.isRecaptura)}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-700">
                      {item?.expedicao?.orgao || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
    </section>
  );
}
